import React from 'react';
export const Footer: React.FC = () => {
  return <footer className="bg-brand-primary text-brand-cream/60 py-12 px-4 md:px-8 border-t border-brand-medium/30" data-id="element-63">
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row justify-between items-center" data-id="element-64">
        <div className="mb-6 md:mb-0 text-center md:text-left" data-id="element-65">
          <h3 className="font-serif text-2xl font-bold text-white mb-2" data-id="element-66">
            COCINA VIANDERA
          </h3>
          <p className="text-sm" data-id="element-67">
            © {new Date().getFullYear()} Todos los derechos reservados.
          </p>
        </div>

        <div className="flex space-x-6 text-sm" data-id="element-68">
          <a href="#" className="hover:text-white transition-colors" data-id="element-69">
            Contacto
          </a>
          <a href="#" className="hover:text-white transition-colors" data-id="element-70">
            Política de devolución
          </a>
        </div>
      </div>
    </footer>;
};